import { PastureForm } from 'src/@types/validations/Local'
import { CreatePastureHistoricDto, PastureDto, PastureHistoricDto } from 'src/dto/pasture.dto'
import { PastureService } from 'src/services/api/pasture.service'

export class PastureController {
  private service: PastureService

  constructor() {
    this.service = new PastureService()
  }

  public async getPastureList(farmId: string): Promise<PastureDto[]> {
    const response = await this.service.getPastureList(farmId)
    return response.data
  }

  public async getPastureById(farmId: string, id: string): Promise<PastureDto> {
    const response = await this.service.getPastureById(farmId, id)
    return response.data
  }

  public async getPastureHistoricById(farmId: string, id: string): Promise<PastureHistoricDto[]> {
    const response = await this.service.getPastureHistoricById(farmId, id)
    return response.data
  }

  public async updatePasture(farmId: string, data: PastureForm): Promise<PastureDto> {
    const response = await this.service.updatePasture(farmId, data)
    return response.data
  }

  public async createPastureHistoric(farmId: string, data: CreatePastureHistoricDto): Promise<PastureHistoricDto> {
    const response = await this.service.createPastureHistoric(farmId, data)
    return response.data
  }
}
